const LOCAL_STORAGE_PREFIX: string = 'attributestore-';

export { LOCAL_STORAGE_PREFIX };
